var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.color)?_c('span',{style:([_vm.color ? { 'color': _vm.color } : { }])},_vm._l((_vm.stars),function(star){return _c('font-awesome-icon',{key:star.id,attrs:{"icon":_vm.getStyle(star)}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }